import { render, staticRenderFns } from "./AssetMenu.vue?vue&type=template&id=2df7a60b&"
import script from "./AssetMenu.vue?vue&type=script&lang=ts&"
export * from "./AssetMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports